import { useContext } from 'react';
import { authContext } from '../../../routes';

const NavConfig = () => {
  const { user } = useContext(authContext);

  const navConfig = [
    {
      title: 'ዋና ገጽ',
      path: '/dashboard/app',
      icon: 'carbon:dashboard',
      canView: user && user.role.permissions.churchLevel.read,
    },
    {
      title: 'ሀገረ ስብከት',
      path: '/dashboard/diocese',
      icon: 'mdi:castle',
      canView: user && user.role.permissions.dioceseUser.create ||  user && user.role.permissions.dioceseChurch.create,
      subList: [{
        title: 'አድባራት',
        path: '/dashboard/dioceseChurch',
        icon: 'mdi:church',
        canView: user && user.role.permissions.dioceseChurch.create,
      },
      {
        title: 'ተከታዮች',
        path: '/dashboard/dioceseUser',
        icon: 'fluent:people-team-16-filled',
        canView: user && user.role.permissions.dioceseUser.create,
      },
      ]
    },
    {
      title: 'ወረዳ',
      path: '/dashboard/district',
      icon: 'fa-solid:map-marked-alt',
      canView: user && user.role.permissions.dioceseLevel.read,
    },
    {
      title: 'አድባራት',
      path: '/dashboard/church',
      icon: 'mdi:church',
      canView: user && user.role.permissions.districtLevel.read,
    },
    {
      title: 'ተከታዮች',
      path: '/dashboard/user',
      icon: 'fluent:people-team-16-filled',
      canView: user && user.role.permissions.churchLevel.delete, // Deletion is not given for admins who monitor users monitored by diocese church.
    },
    {
      title: 'ምድብ',
      path: '/dashboard/category',
      icon: 'ic:twotone-family-restroom',
      canView: user && user.role.permissions.category.create,
    },
    {
      title: 'ሚና',
      path: '/dashboard/role',
      icon: 'carbon:badge',
      canView: user && user.role.permissions.role.create,
    },
    {
      title: 'መልዕክቶች',
      path: '/dashboard/contact',
      icon: 'ic:baseline-chat-bubble-outline',
      canView: user && user.role.permissions.contact.read,
    },
    {
      title: 'ክፍያ',
      path: '/dashboard/payment',
      icon: 'fa-solid:money-bill-alt',
      canView: user && user.role.permissions.payment.read,
    },
    {
      title: 'ልጆቼ',
      path: '/dashboard/confessorChild',
      icon: 'fluent:people-team-16-filled',
      canView: true, // user && user.category.type === 'confessor', // Deletion is not given for admins who monitor users monitored by diocese church.
    },
    {
      title: 'ውይይት',
      path: '/dashboard/chat',
      icon: 'ic:round-chat',
      canView: user && user.role.permissions.publicChat.read,
    },
  ];

  const allowedNavConfigs = navConfig.filter((item) => item.canView);

  return allowedNavConfigs;
};

export default NavConfig;
